<template>
  <add :show-header="false" is-editor show-member-tips :show-background-color="false" />
</template>

<script>
import Add from '@/views/project/children/Add'
export default {
  name: 'Info',
  components: {
    Add
  },
  data () {
    return {
      //
    }
  },
  mounted () {
  },
  methods: {}
}
</script>

<style scoped>

</style>
